import { useContext } from 'react';
import { FeatureFlagsContext } from '../components/FeatureFlagsContext';
export const useAreFeatureFlagsLoaded = () => {
  const context = useContext(FeatureFlagsContext);
  return !context.loading;
};